import { render, staticRenderFns } from "./InvoiceDetails.vue?vue&type=template&id=4b78264a&scoped=true"
import script from "./InvoiceDetails.vue?vue&type=script&lang=js"
export * from "./InvoiceDetails.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDetails.vue?vue&type=style&index=0&id=4b78264a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b78264a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b78264a')) {
      api.createRecord('4b78264a', component.options)
    } else {
      api.reload('4b78264a', component.options)
    }
    module.hot.accept("./InvoiceDetails.vue?vue&type=template&id=4b78264a&scoped=true", function () {
      api.rerender('4b78264a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/invoices/InvoiceDetails.vue"
export default component.exports